import {Component, CSSProperties, PureComponent} from 'react'
import * as alpha from '../../helpers/alpha'
let React = require('react');
import Checkboard from './Checkboard'

export class Alpha extends (PureComponent || Component) {
  props:any;
  container:any;
  componentWillUnmount() {
    this.unbindEventListeners()
  }

  handleChange = (e) => {
    const change = alpha.calculateChange(e, this.props.hsl, this.props.direction, this.props.a, this.container)
    change && typeof this.props.onChange === 'function' && this.props.onChange(change, e)
  }

  handleMouseDown = (e) => {
    this.handleChange(e)
    window.addEventListener('mousemove', this.handleChange)
    window.addEventListener('mouseup', this.handleMouseUp)
  }

  handleMouseUp = () => {
    this.unbindEventListeners()
  }

  unbindEventListeners = () => {
    window.removeEventListener('mousemove', this.handleChange)
    window.removeEventListener('mouseup', this.handleMouseUp)
  }

  render() {
    const rgb = this.props.rgb
    const styles = {
        alpha: {
          position:'absolute',
          too:'0',
          left:'0',
          right:'0',
          bottom:'0',
          borderRadius: this.props.radius,
        },
        checkboard: {
          position:'absolute',
          too:'0',
          left:'0',
          right:'0',
          bottom:'0',
          overflow: 'hidden',
          borderRadius: this.props.radius,
        },
        gradient: {
          position:'absolute',
          too:'0',
          left:'0',
          right:'0',
          bottom:'0',
          background: `linear-gradient(to right, rgba(${ rgb.r },${ rgb.g },${ rgb.b }, 0) 0%,
           rgba(${ rgb.r },${ rgb.g },${ rgb.b }, 1) 100%)`,
          boxShadow: this.props.shadow,
          borderRadius: this.props.radius,
        },
        container: {
          position: 'relative',
          height: '100%',
          margin: '0 3px',
        },
        pointer: {
          position: 'absolute',
          left: `${ rgb.a * 100 }%`,
        },
        slider: {
          width: '4px',
          borderRadius: '1px',
          height: '8px',
          boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
          background: '#fff',
          marginTop: '1px',
          transform: 'translateX(-2px)',
        },
      };

    return (
      <div style={ styles.alpha as CSSProperties }>
        <div style={ styles.checkboard as CSSProperties }>
          <Checkboard renderers={ this.props.renderers } />
        </div>
        <div style={ styles.gradient as CSSProperties } />
        <div
          style={ styles.container as CSSProperties }
          ref={ container => this.container = container }
          onMouseDown={ this.handleMouseDown }
          onTouchMove={ this.handleChange }
          onTouchStart={ this.handleChange }
        >
          <div style={ styles.pointer as CSSProperties }>
            { this.props.pointer ? (
              <this.props.pointer { ...this.props } />
            ) : (
              <div style={ styles.slider } />
            ) }
          </div>
        </div>
      </div>
    )
  }
}

export default Alpha
